import React, { useState } from 'react';
import { compose } from 'redux';
import { injectIntl } from '../../util/reactIntl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withViewport } from '../../util/contextHelpers';
import config from '../../config';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  FaqDropdown,
  JoinPreFooter,
} from '../../components';
import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { IoIosArrowDown } from 'react-icons/io';
import { FaCircleCheck } from 'react-icons/fa6';

import css from './StartBuyingInfoPage.css';
import infoImage from '../../assets/start-buying-info.png';
import info2Image from '../../assets/start-buying-info2.png';
import info2ImageEN from '../../assets/start-buying-info2-en.png';
import testimonialImg from '../../assets/heikki-rostila-quote.png';

export const StartBuyingInfoPageComponent = props => {
  const { intl, scrollingDisabled, history, location, viewport } = props;

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'StartBuyingInfoPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'StartBuyingInfoPage.schemaDescription' });
  const locale = config.locale;

  // Choose image based on locale
  const info2ImageToUse = locale === 'en' ? info2ImageEN : info2Image;

  const faqQuestion1 = <FormattedMessage id="StartBuyingInfoPage.faqQuestion1" />;
  const faqQuestion2 = <FormattedMessage id="StartBuyingInfoPage.faqQuestion2" />;
  const faqQuestion3 = <FormattedMessage id="StartBuyingInfoPage.faqQuestion3" />;
  const faqQuestion4 = <FormattedMessage id="StartBuyingInfoPage.faqQuestion4" />;
  const faqQuestion5 = <FormattedMessage id="StartBuyingInfoPage.faqQuestion5" />;

  const faqAnswer1 = (
    <div>
      <b>
        <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Subtitle1" />
      </b>
      <br />
      <br />
      <ul className={css.faqList}>
        <li>
          <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Item1" />
        </li>
        <li>
          <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Item2" />
        </li>
        <li>
          <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Item3" />
        </li>
        <li>
          <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Item4" />
        </li>
        <li>
          <FormattedMessage id="StartBuyingInfoPage.faqAnswer1Item5" />
        </li>
      </ul>
    </div>
  );

  const faqAnswer2 = (
    <div>
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer2Item1" />
      <br />
      <br />
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer2Item2" />
      <br />
      <br />
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer2Item3" />
    </div>
  );

  const faqAnswer3 = (
    <div>
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer3Item1" />
    </div>
  );

  const faqAnswer4 = (
    <div>
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer4Item1" />
      <br />
      <br />
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer4Item2" />
    </div>
  );

  const faqAnswer5 = (
    <div>
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer5Item1" />
      <br />
      <br />
      <FormattedMessage id="StartBuyingInfoPage.faqAnswer5Item2" />
    </div>
  );

  const [faqIsShown, setFaqIsShown] = useState([
    {
      question: faqQuestion1,
      answer: faqAnswer1,
      index: 0,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion2,
      answer: faqAnswer2,
      index: 1,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion3,
      answer: faqAnswer3,
      index: 2,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion4,
      answer: faqAnswer4,
      index: 3,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion5,
      answer: faqAnswer5,
      index: 4,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
  ]);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="StartBuyingInfoPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={css.heroSection}>
                <div className={css.heroBadge}>
                  <FormattedMessage id="StartBuyingInfoPage.heroBadge" />
                </div>
                <h1 className={css.heroTitle}>
                  <FormattedMessage id="StartBuyingInfoPage.heroTitle" />
                </h1>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.stepCard}>
                <div className={css.stepContent}>
                  <div className={css.stepTextSection}>
                    <h2 className={css.stepTitle}>
                      <FormattedMessage id="StartBuyingInfoPage.step1Title" />
                    </h2>
                    <p className={css.stepDescription}>
                      <FormattedMessage id="StartBuyingInfoPage.step1Description" />
                    </p>
                  </div>
                  <div className={css.stepBullets}>
                    <div className={css.bulletItem}>
                      <div className={css.bulletIcon}>
                        <FaCircleCheck className={css.bulletIconCheck} />
                      </div>
                      <p className={css.bulletText}>
                        <FormattedMessage id="StartBuyingInfoPage.step1Bullet1" />
                      </p>
                    </div>
                    <div className={css.bulletItem}>
                      <div className={css.bulletIcon}>
                        <FaCircleCheck className={css.bulletIconCheck} />
                      </div>
                      <p className={css.bulletText}>
                        <FormattedMessage id="StartBuyingInfoPage.step1Bullet2" />
                      </p>
                    </div>
                  </div>
                </div>
                <div className={css.stepImageContainer}>
                  <img src={infoImage} alt="Find freelancer" className={css.stepImage} />
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.stepCard}>
                <div className={css.stepContent}>
                  <div className={css.stepTextSection}>
                    <h2 className={css.stepTitle}>
                      <FormattedMessage id="StartBuyingInfoPage.step2Title" />
                    </h2>
                    <p className={css.stepDescription}>
                      <FormattedMessage id="StartBuyingInfoPage.step2Description" />
                    </p>
                  </div>
                  <div className={css.stepBullets}>
                    <div className={css.bulletItem}>
                      <div className={css.bulletIcon}>
                        <FaCircleCheck className={css.bulletIconCheck} />
                      </div>
                      <p className={css.bulletText}>
                        <FormattedMessage id="StartBuyingInfoPage.step2Bullet1" />
                      </p>
                    </div>
                    <div className={css.bulletItem}>
                      <div className={css.bulletIcon}>
                        <FaCircleCheck className={css.bulletIconCheck} />
                      </div>
                      <p className={css.bulletText}>
                        <FormattedMessage id="StartBuyingInfoPage.step2Bullet2" />
                      </p>
                    </div>
                  </div>
                </div>
                <div className={css.stepImageContainer}>
                  <img src={info2ImageToUse} alt="Collaboration" className={css.stepImage} />
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.testimonialSection}>
                <div className={css.testimonialContent}>
                  <img
                    src={testimonialImg}
                    alt="Heikki Rostila"
                    className={css.testimonialImageDesktop}
                  />
                  <div className={css.testimonialText}>
                    <p className={css.testimonialQuote}>
                      <FormattedMessage id="StartBuyingInfoPage.testimonialQuote" />
                    </p>
                    <div className={css.testimonialAuthor}>
                      <img
                        src={testimonialImg}
                        alt="Heikki Rostila"
                        className={css.testimonialImage}
                      />
                      <div className={css.testimonialAuthorText}>
                        <p className={css.testimonialName}>
                          <FormattedMessage id="StartBuyingInfoPage.testimonialName" />
                        </p>
                        <p className={css.testimonialTitle}>
                          <FormattedMessage id="StartBuyingInfoPage.testimonialTitle" />
                        </p>
                      </div>
                    </div>
                    <div className={css.testimonialAuthorDesktop}>
                      <p className={css.testimonialName}>
                        <FormattedMessage id="StartBuyingInfoPage.testimonialName" />
                      </p>
                      <p className={css.testimonialTitle}>
                        <FormattedMessage id="StartBuyingInfoPage.testimonialTitle" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionFAQContent}>
                <div className={css.sectionFAQTitle}>
                  <FormattedMessage id="StartBuyingInfoPage.faqSectionTitle" />
                </div>
                <FaqDropdown faqIsShown={faqIsShown} setFaqIsShown={setFaqIsShown} />
              </div>
            </li>
          </ul>
          <JoinPreFooter />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

StartBuyingInfoPageComponent.defaultProps = {
  currentUser: null,
};

StartBuyingInfoPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const StartBuyingInfoPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(StartBuyingInfoPageComponent);

export default StartBuyingInfoPage;
